import { TV_SPOT_IDS } from './tvSpotLocation';
import { TV_BROADCAST_PERIODS } from './tvBroadcastPeriod';
import { TV_BROADCAST_MODES } from './tvBroadcastMode';

const FRAME_INTRO = { id: 1, title: '導入', short: 'INTRO', kind: 'intro' };
const FRAME_ACTION = { id: 99, title: '行動提案・詳細へ', short: 'ACTION', kind: 'action' };

/** 朝昼：昨日（4地点）→ 今日（各エリア）→ 週間 */
export const TV_BROADCAST_SEQUENCE_MORNING = [
  FRAME_INTRO,
  { id: 2, title: 'きのうの流れ', short: 'YESTERDAY', kind: 'yesterdayOverview' },
  { id: 3, title: '駅前・今日', short: 'STATION_TODAY', kind: 'spotToday', spotId: TV_SPOT_IDS.STATION },
  { id: 4, title: '古い町並み・今日', short: 'OLD_TOWN_TODAY', kind: 'spotToday', spotId: TV_SPOT_IDS.OLD_TOWN },
  { id: 5, title: '駅前・週間', short: 'STATION_WEEK', kind: 'spotWeek', spotId: TV_SPOT_IDS.STATION },
  { id: 6, title: '古い町並み・週間', short: 'OLD_TOWN_WEEK', kind: 'spotWeek', spotId: TV_SPOT_IDS.OLD_TOWN },
  { ...FRAME_ACTION, id: 7 },
];

/** @deprecated TV_BROADCAST_SEQUENCE_MORNING を使用 */
export const TV_BROADCAST_SEQUENCE_DAYTIME = TV_BROADCAST_SEQUENCE_MORNING;

/** 夜：今日（4地点）→ 明日 → 週間 */
export const TV_BROADCAST_SEQUENCE_EVENING = [
  FRAME_INTRO,
  { id: 2, title: '今日の流れ', short: 'TODAY', kind: 'todayOverview' },
  { id: 3, title: '駅前・明日', short: 'STATION_TOMORROW', kind: 'spotTomorrow', spotId: TV_SPOT_IDS.STATION },
  { id: 4, title: '古い町並み・明日', short: 'OLD_TOWN_TOMORROW', kind: 'spotTomorrow', spotId: TV_SPOT_IDS.OLD_TOWN },
  { id: 5, title: '駅前・週間', short: 'STATION_WEEK', kind: 'spotWeek', spotId: TV_SPOT_IDS.STATION },
  { id: 6, title: '古い町並み・週間', short: 'OLD_TOWN_WEEK', kind: 'spotWeek', spotId: TV_SPOT_IDS.OLD_TOWN },
  { ...FRAME_ACTION, id: 7 },
];

/** @deprecated TV_BROADCAST_SEQUENCE_DAYTIME を使用 */
export const TV_BROADCAST_SEQUENCE = TV_BROADCAST_SEQUENCE_DAYTIME;

/**
 * 週間版（週1更新・会議比較用プロトタイプ）
 * 合計 durationSeconds = 75（目安 65〜75 秒）
 */
export const TV_WEEKLY_FRAMES = [
  {
    id: 1,
    key: 'weekly-intro',
    title: '導入',
    short: 'W_INTRO',
    kind: 'weeklyIntro',
    durationSeconds: 10,
    showQr: false,
  },
  {
    id: 2,
    key: 'previous-week',
    title: '先週の計測',
    short: 'PREV_WEEK',
    kind: 'previousWeek',
    durationSeconds: 20,
    showQr: false,
  },
  {
    id: 3,
    key: 'next-week',
    title: '今週の予測',
    short: 'NEXT_WEEK',
    kind: 'nextWeek',
    durationSeconds: 30,
    showQr: false,
  },
  {
    id: 4,
    key: 'web-guide',
    title: 'Web案内',
    short: 'WEB',
    kind: 'webGuide',
    durationSeconds: 15,
    showQr: true,
  },
];

export function getTvBroadcastSequence(broadcastPeriod) {
  if (broadcastPeriod === TV_BROADCAST_PERIODS.EVENING) {
    return TV_BROADCAST_SEQUENCE_EVENING;
  }
  return TV_BROADCAST_SEQUENCE_MORNING;
}

export function getTvSequenceForMode(broadcastMode, broadcastPeriod) {
  if (broadcastMode === TV_BROADCAST_MODES.WEEKLY) {
    return TV_WEEKLY_FRAMES;
  }
  return getTvBroadcastSequence(broadcastPeriod);
}

export function getTvSequenceTotalSeconds(frames) {
  return (frames || []).reduce((sum, frame) => sum + (frame.durationSeconds || 0), 0);
}

/** daily: 行動提案以外に QR。weekly: frame.showQr を正とする */
export function shouldShowTvFrameQr(frame, broadcastMode) {
  if (broadcastMode === TV_BROADCAST_MODES.WEEKLY) {
    return Boolean(frame?.showQr);
  }
  return frame?.kind !== 'action';
}

export const isTvActionFrame = (frame) => frame?.kind === 'action';

/** @deprecated isTvActionFrame を使用 */
export const TV_ACTION_FRAME_ID = 7;
